import type { IProps, ModalFooterActionsDoneFactory } from "./modal-footer-actions-done.types";
import styles from "../../../modal.module.scss";
import { polymorphicComponentWrapper } from "../../../../../utilities";
import { Button } from "../../../../button";
import { faCheck } from "@fortawesome/pro-solid-svg-icons";

const ModalFooterActionsDone = polymorphicComponentWrapper<ModalFooterActionsDoneFactory, IProps>(
    "ModalFooterActionsDone",
    ({ text, icon, ...otherProps }, ref) => {
        return (
            <Button
                variant="filled"
                ref={ref}
                icon={icon ?? faCheck}
                className={styles["footer-actions-done"]}
                data-testid="done-button"
                {...otherProps}
            >
                {text || "Done"}
            </Button>
        );
    }
);

export { ModalFooterActionsDone };
